"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var DOCUMENT_TYPES = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var _default = [DOCUMENT_TYPES.ADDITION, DOCUMENT_TYPES.AMENDMENT, DOCUMENT_TYPES.CERTIFICATE_OF_COMPLETION, DOCUMENT_TYPES.CERTIFICATE_OF_COUNSELING, DOCUMENT_TYPES.CREDIT_REPORT, DOCUMENT_TYPES.JUDGMENT, DOCUMENT_TYPES.MEDICAL_RECORD, DOCUMENT_TYPES.PACKET_FILING, DOCUMENT_TYPES.PAY_DAY_LOAN, DOCUMENT_TYPES.PAY_STUB, DOCUMENT_TYPES.PETITION, DOCUMENT_TYPES.TAX_RETURN, DOCUMENT_TYPES.UTILITY];
exports["default"] = _default;